import styled from "styled-components"

const DOT_FORMATTING = `
    border-radius: 50%;
    background-color: black;
`

const DieContainer = styled.div`
    width: 200px;
    height: 200px;
    padding: 10px;
    border: thin solid black;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-gap: 5px;

    ${
        (props) => {
            switch(props.number){
                case 1:
                    return `
                        & > :nth-child(5){
                            ${DOT_FORMATTING}
                        }
                    `;
                case 2:
                    return `
                    & > :nth-child(1), > :nth-child(9){
                        ${DOT_FORMATTING}
                    }
                    `;
                case 3:
                    return `
                    & > :nth-child(3), > :nth-child(5),> :nth-child(7){
                        ${DOT_FORMATTING}
                    }
                    `;
                case 4:
                    return `
                    & > :nth-child(1), > :nth-child(3),
                     > :nth-child(7), > :nth-child(9){
                        ${DOT_FORMATTING}
                    }`;
                case 5:
                    return `
                    & > :nth-child(1), > :nth-child(3),
                     > :nth-child(7), > :nth-child(9), > :nth-child(5){
                        ${DOT_FORMATTING}
                    }`;
                case 6:
                    return `
                    & > :nth-child(1), > :nth-child(4),
                     > :nth-child(7), > :nth-child(3), > :nth-child(6), > :nth-child(9){
                        ${DOT_FORMATTING}
                    }`;
                default:
                    return "";
            }
        }
    }
`

export const Die = ({number}) => {

    return (<DieContainer number={number}>
        <div class="top-left"></div>
        <div class="top-middle"></div>
        <div class="top-right"></div>

        <div class="middle-left"></div>
        <div class="middle-middle"></div>
        <div class="middle-right"></div>

        <div class="bottom-left"></div>
        <div class="bottom-middle"></div>
        <div class="bottom-right"></div>

    </DieContainer>);
}